import { MayoristasCollection } from "./MayoristasProducts";

export const LastCollectionMayoristas: MayoristasCollection = {
    "Mulco": [
        {
            "id": "MLCM101",
            "name": "Mulco para dama",
            "color": "Dorado con detalles de color rosa",
            "description": "Este reloj Mulco destaca por su diseño elegante y lleno de detalles que resaltan su estilo femenino y sofisticado. Su carátula incorpora formas y relieves que crean una apariencia dinámica y moderna, acompañada de indicadores bien definidos y una ventana de fecha integrada de manera armoniosa.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/mulco+1.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "MLCM102",
            "name": "Mulco para dama",
            "color": "Plateado",
            "description": "Este reloj Mulco destaca por su diseño elegante y lleno de detalles que resaltan su estilo femenino y sofisticado. Su carátula incorpora formas y relieves que crean una apariencia dinámica y moderna, acompañada de indicadores bien definidos y una ventana de fecha integrada de manera armoniosa.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/mulco+2.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "MLCM103",
            "name": "Mulco para dama",
            "color": "Plateado con detalles de color morado",
            "description": "Este reloj Mulco destaca por su diseño elegante y lleno de detalles que resaltan su estilo femenino y sofisticado. Su carátula incorpora formas y relieves que crean una apariencia dinámica y moderna, acompañada de indicadores bien definidos y una ventana de fecha integrada de manera armoniosa.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/mulco+3.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "MLCM104",
            "name": "Mulco para dama",
            "color": "Dorado con detalles de color morado",
            "description": "Este reloj Mulco destaca por su diseño elegante y lleno de detalles que resaltan su estilo femenino y sofisticado. Su carátula incorpora formas y relieves que crean una apariencia dinámica y moderna, acompañada de indicadores bien definidos y una ventana de fecha integrada de manera armoniosa.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/mulco+4.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Rolex Dweller": [
        {
            "id": "RLXLDM101",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula verde",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+1.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM102",
            "name": "Rolex Land Dweller",
            "color": "Dorado con carátula blanca",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+2.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM103",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula negra y detalles dorados",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+3.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM104",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula blanca y detalles dorados",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+4.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM105",
            "name": "Rolex Land Dweller",
            "color": "Dorado con carátula azul",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+5.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM106",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula negra",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+6.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM107",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula blanca",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+7.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM108",
            "name": "Rolex Land Dweller",
            "color": "Dorado con carátula verde",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+8.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM109",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula azul",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+9.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM110",
            "name": "Rolex Land Dweller",
            "color": "Dorado con carátula beige",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+10.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "RLXLDM111",
            "name": "Rolex Land Dweller",
            "color": "Plateado con carátula verde y detalles dorados",
            "description": "Este modelo destaca por su diseño refinado y una carátula con patrón geométrico que aporta textura y profundidad visual.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/rolex+dweller+11.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Q-Q": [
        {
            "id": "Q&QFLM101",
            "name": "Q&Q para dama",
            "color": "Plateado",
            "description": "Este reloj Q&Q presenta un diseño delicado y minimalista que resalta por su elegancia y simplicidad. Su carátula incorpora un patrón radial que aporta profundidad visual y un estilo sutilmente moderno, acompañado de marcadores finos que permiten una lectura clara del tiempo",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Q%26Q+fondo+lineas+1.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "Q&QFLM102",
            "name": "Q&Q para dama",
            "color": "Dorado con detalles en azul",
            "description": "Este reloj Q&Q presenta un diseño delicado y minimalista que resalta por su elegancia y simplicidad. Su carátula incorpora un patrón radial que aporta profundidad visual y un estilo sutilmente moderno, acompañado de marcadores finos que permiten una lectura clara del tiempo",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Q%26Q+fondo+lineas+2.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "Q&QFLM103",
            "name": "Q&Q para dama",
            "color": "Plateado con detalles en rosa",
            "description": "Este reloj Q&Q presenta un diseño delicado y minimalista que resalta por su elegancia y simplicidad. Su carátula incorpora un patrón radial que aporta profundidad visual y un estilo sutilmente moderno, acompañado de marcadores finos que permiten una lectura clara del tiempo",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Q%26Q+fondo+lineas+3.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "Q&QFLM104",
            "name": "Q&Q para dama",
            "color": "Plateado con detalles en azul",
            "description": "Este reloj Q&Q presenta un diseño delicado y minimalista que resalta por su elegancia y simplicidad. Su carátula incorpora un patrón radial que aporta profundidad visual y un estilo sutilmente moderno, acompañado de marcadores finos que permiten una lectura clara del tiempo",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Q%26Q+fondo+lineas+4.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "Q&QCOLM101",
            "name": "Q&Q OFICIAL seleccion Colombia",
            "color": "Amarillo, azul y rojo",
            "description": "Edición especial inspirada en la Seleccion Colombia",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Q%26Q+colombia+1.JPG",
            "price": 45000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Fossil": [
        {
            "id": "FSSM101",
            "name": "Fossil",
            "color": "Plateado con detalles en negro",
            "description": "Reloj de estilo moderno con diseño multifuncional que combina elegancia y practicidad en una sola pieza.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Fossil+acero+1.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "FSSM102",
            "name": "Fossil",
            "color": "Plateado con detalles en azul y negro",
            "description": "Reloj de estilo moderno con diseño multifuncional que combina elegancia y practicidad en una sola pieza.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Fossil+acero+1.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "FSSM103",
            "name": "Fossil",
            "color": "Plateado con detalles en negro y rojo",
            "description": "Reloj de estilo moderno con diseño multifuncional que combina elegancia y practicidad en una sola pieza.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/Fossil+acero+1.JPG",
            "price": 55000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Orient": [
        {
            "id": "ORTM101",
            "name": "Orient para dama",
            "color": "Plateado con detalles en rojo",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+1.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM102",
            "name": "Orient para dama",
            "color": "Plateado",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+2.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM103",
            "name": "Orient para dama",
            "color": "Dorado con detalles en negro",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+3.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM104",
            "name": "Orient para dama",
            "color": "Dorado con detalles en azul",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+4.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM105",
            "name": "Orient para dama",
            "color": "Plateado con detalles en negro",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+5.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM106",
            "name": "Orient para dama",
            "color": "Dorado con detalles en dorado y verde",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+6.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM107",
            "name": "Orient para dama",
            "color": "Dorado con detalles en blanco",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+7.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "ORTM108",
            "name": "Orient para dama",
            "color": "Dorado",
            "description": "Este reloj Orient combina elegancia clásica con la precisión de un movimiento automático. La caja mantiene líneas limpias y equilibradas que resaltan su estilo refinado, mientras que la pulsera metálica completa el conjunto con un acabado sólido y cómodo.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/orient+dama+8.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Audemars Piguet": [
        {
            "id": "APCM101",
            "name": "Audemars Piguet Cubano",
            "color": "Dorado",
            "description": "Este modelo destaca por su diseño imponente y lleno de detalles que reflejan un estilo audaz y sofisticado. La caja presenta un bisel decorado con múltiples incrustaciones que aportan un brillo intenso y una presencia llamativa en la muñeca.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ap+cubano+1.JPG",
            "price": 65000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "APCM102",
            "name": "Audemars Piguet Cubano",
            "color": "Plateado",
            "description": "Este modelo destaca por su diseño imponente y lleno de detalles que reflejan un estilo audaz y sofisticado. La caja presenta un bisel decorado con múltiples incrustaciones que aportan un brillo intenso y una presencia llamativa en la muñeca.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ap+cubano+2.JPG",
            "price": 65000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "APCM103",
            "name": "Audemars Piguet Cubano",
            "color": "Plateado con detalles dorados",
            "description": "Este modelo destaca por su diseño imponente y lleno de detalles que reflejan un estilo audaz y sofisticado. La caja presenta un bisel decorado con múltiples incrustaciones que aportan un brillo intenso y una presencia llamativa en la muñeca.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ap+cubano+3.JPG",
            "price": 65000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "BMW Rin Giratorio": [
        {
            "id": "BMWRGM101",
            "name": "BMW Rin Giratorio",
            "color": "Negro con detalles en rojo",
            "description": "Este reloj inspirado en BMW destaca por su diseño único que simula el rin de un automóvil deportivo, creando una pieza llamativa y llena de personalidad. Su carátula reproduce los detalles de un sistema de freno con un efecto de rin giratorio que añade dinamismo al movimiento del reloj.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/bmw+rin+giratorio+1.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "BMWRGM102",
            "name": "BMW Rin Giratorio",
            "color": "Negro con detalles en azul",
            "description": "Este reloj inspirado en BMW destaca por su diseño único que simula el rin de un automóvil deportivo, creando una pieza llamativa y llena de personalidad. Su carátula reproduce los detalles de un sistema de freno con un efecto de rin giratorio que añade dinamismo al movimiento del reloj.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/bmw+rin+giratorio+2.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "BMWRGM103",
            "name": "BMW Rin Giratorio",
            "color": "Negro con detalles en verde",
            "description": "Este reloj inspirado en BMW destaca por su diseño único que simula el rin de un automóvil deportivo, creando una pieza llamativa y llena de personalidad. Su carátula reproduce los detalles de un sistema de freno con un efecto de rin giratorio que añade dinamismo al movimiento del reloj.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/bmw+rin+giratorio+3.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "BMWRGM104",
            "name": "BMW Rin Giratorio",
            "color": "Negro con detalles en amarillo",
            "description": "Este reloj inspirado en BMW destaca por su diseño único que simula el rin de un automóvil deportivo, creando una pieza llamativa y llena de personalidad. Su carátula reproduce los detalles de un sistema de freno con un efecto de rin giratorio que añade dinamismo al movimiento del reloj.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/bmw+rin+giratorio+4.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "BMWRGM105",
            "name": "BMW Rin Giratorio",
            "color": "Negro con detalles en blanco",
            "description": "Este reloj inspirado en BMW destaca por su diseño único que simula el rin de un automóvil deportivo, creando una pieza llamativa y llena de personalidad. Su carátula reproduce los detalles de un sistema de freno con un efecto de rin giratorio que añade dinamismo al movimiento del reloj.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/bmw+rin+giratorio+5.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Invicta": [
        {
            "id": "IVTM101",
            "name": "Invicta",
            "color": "Negro con detalles en blanco y rojo",
            "description": "",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/invicta+lazo+1.JPG",
            "price": 65000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "IVTM102",
            "name": "Invicta",
            "color": "Azul con detalles en blanco",
            "description": "",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/invicta+lazo+2.JPG",
            "price": 65000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "IVTM103",
            "name": "Invicta",
            "color": "Negro con detalles en rojo",
            "description": "",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/invicta+lazo+3.JPG",
            "price": 65000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ],
    "Ferrari Rin Giratorio": [
        {
            "id": "FRRRGM101",
            "name": "Ferrari Rin Giratorio",
            "color": "Negro con detalles en azul",
            "description": "Este reloj inspirado en Ferrari presenta un diseño deportivo que captura la esencia del mundo automotriz. Su carátula reproduce la estética de un rin de alto rendimiento con un efecto giratorio que aporta dinamismo y originalidad a cada movimiento.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ferrari+rin+giratorio+1.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "FRRRGM102",
            "name": "Ferrari Rin Giratorio",
            "color": "Negro con detalles en rojo",
            "description": "Este reloj inspirado en Ferrari presenta un diseño deportivo que captura la esencia del mundo automotriz. Su carátula reproduce la estética de un rin de alto rendimiento con un efecto giratorio que aporta dinamismo y originalidad a cada movimiento.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ferrari+rin+giratorio+2.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "FRRRGM103",
            "name": "Ferrari Rin Giratorio",
            "color": "Negro con detalles en amarillo",
            "description": "Este reloj inspirado en Ferrari presenta un diseño deportivo que captura la esencia del mundo automotriz. Su carátula reproduce la estética de un rin de alto rendimiento con un efecto giratorio que aporta dinamismo y originalidad a cada movimiento.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ferrari+rin+giratorio+3.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "FRRRGM104",
            "name": "Ferrari Rin Giratorio",
            "color": "Negro con detalles en verde",
            "description": "Este reloj inspirado en Ferrari presenta un diseño deportivo que captura la esencia del mundo automotriz. Su carátula reproduce la estética de un rin de alto rendimiento con un efecto giratorio que aporta dinamismo y originalidad a cada movimiento.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ferrari+rin+giratorio+4.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        },
        {
            "id": "FRRRGM105",
            "name": "Ferrari Rin Giratorio",
            "color": "Negro con detalles en blanco",
            "description": "Este reloj inspirado en Ferrari presenta un diseño deportivo que captura la esencia del mundo automotriz. Su carátula reproduce la estética de un rin de alto rendimiento con un efecto giratorio que aporta dinamismo y originalidad a cada movimiento.",
            "presentacion": "Incluye caja de presentacion",
            "imgUrl": "https://relojes-s-l.s3.us-west-1.amazonaws.com/MAYORISTAS/ferrari+rin+giratorio+5.JPG",
            "price": 40000,
            "notes": "Recuerda confirmar por disponibilidad en nuestra linea de whatsapp.",
        }
    ]
}
